export const AVIF = "image/avif";
export const WEBP = "image/webp";
export const PNG = "image/png";
export const JPEG = "image/jpeg";
export const GIF = "image/gif";
export const SVG = "image/svg+xml";
